export const itemImageSize = {
    "1": "full",
    "2": "large",
    "3": "medium",
    "4": "medium",
};
export const itemSkin1Width = {
    "1": "94rem",
    "2": "46.4rem",
    "3": "30.4rem",
    "4": "22.4rem",
};
export const itemSkin2Style = {
    "1": {
        height: "44rem",
        left: "2.4rem",
        bottom: {
            title: "4.4rem",
            text: "2.4rem",
        },
        fontSize: {
            title: "4rem",
            text: "1.6rem",
        },
        opacityLayerHeight: "12.8rem",
    },
    "2": {
        height: "46.2rem",
        left: "2.4rem",
        bottom: {
            title: "4.4rem",
            text: "2.4rem",
        },
        fontSize: {
            title: "3.2rem",
            text: "1.6rem",
        },
        opacityLayerHeight: "12.8rem",
    },
    "3": {
        height: "30.8rem",
        left: "1.6rem",
        bottom: {
            title: "3.2rem",
            text: "1.6rem",
        },
        fontSize: {
            title: "2.4rem",
            text: "1.4rem",
        },
        opacityLayerHeight: "9.6rem",
    },
    "4": {
        height: "22.9rem",
        left: "0.8rem",
        bottom: {
            title: "2.8rem",
            text: "0.8rem",
        },
        fontSize: {
            title: "2.4rem",
            text: "1.4rem",
        },
        opacityLayerHeight: "7.2rem",
    },
};
//# sourceMappingURL=utils.js.map